module.exports = __webpack_public_path__ + "img/section5Logo3.38f10c6d.svg";